import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import useWorkScheduleCalendarContext from 'components/AddWorkSchedule/WorkScheduleCalendar/context/useWorkScheduleCalendarContext';
import getDayValues from 'components/SchedulePreviewCalendar/libComponents/DayScaleCellComponent/getDayValues';
import TooltipIcon from 'common/TooltipIcon/TooltipIcon';
import { daysInWeek } from 'helpers/timeConsts';
import checkIsAnyScheduleInRange from '../checkIsAnyScheduleInRange';
import StyledIconButton from './IconButton.styled';

interface DayScaleCloseIconProps {
  startDate: Date;
}

export default function DayScaleCloseIcon({
  startDate,
}: DayScaleCloseIconProps) {
  const { t } = useTranslation();
  const { workSchedules, schedule, handleDecreaseScheduleDays } =
    useWorkScheduleCalendarContext();
  const { dayWithWeekOffset } = getDayValues({
    startDate,
    isRegularWeek: schedule.regular,
  });

  const shouldDisableCloseIcon = checkIsAnyScheduleInRange({
    dayWithWeekOffset,
    regular: schedule.regular,
    workSchedules,
  });

  if (shouldDisableCloseIcon) {
    return (
      <TooltipIcon
        label={t(
          schedule.regular
            ? 'project_tracking.schedule_week_remove_tooltip'
            : 'project_tracking.schedule_day_remove_tooltip',
        )}
      >
        <StyledIconButton size="small" disabled>
          <CloseIcon fontSize="large" />
        </StyledIconButton>
      </TooltipIcon>
    );
  }

  return (
    <StyledIconButton
      size="small"
      onClick={() => handleDecreaseScheduleDays(schedule.regular ? daysInWeek : 1)}
    >
      <CloseIcon fontSize="large" />
    </StyledIconButton>
  );
}
